// Janela do gráfico §6.5: o chip de 3/6/12 meses só existe no front.
// O GET Y=14 recebe o par `dateFrom`/`dateTo` já calculado.

export const INSPECTION_CHART_PERIODS = [3, 6, 12] as const;

export type InspectionChartPeriodMonths =
  (typeof INSPECTION_CHART_PERIODS)[number];

const PERIOD_MONTHS_I18N_SEGMENT: Record<InspectionChartPeriodMonths, string> = {
  3: "three",
  6: "six",
  12: "twelve",
};

export const inspectionChartPeriodMonthsI18nKey = (
  months: InspectionChartPeriodMonths,
): string =>
  `inspection.chart.periodMonths.${PERIOD_MONTHS_I18N_SEGMENT[months]}`;

const pad = (value: number) => String(value).padStart(2, "0");

const lastDayOfMonthUtc = (year: number, month: number) =>
  new Date(Date.UTC(year, month, 0)).getUTCDate();

const CHART_MONTH_ABBREV_KEYS = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
] as const;

/** Eixo X / tooltip do gráfico §6.5 — `jan/2026` via i18n, a partir de year+month. */
export const formatInspectionChartMonthLabel = (
  year: number,
  month: number,
  translate: (key: string) => string,
): string => {
  const abbrevKey = CHART_MONTH_ABBREV_KEYS[month - 1];
  if (!abbrevKey) return `${month}/${year}`;

  return `${translate(`inspection.chart.monthAbbrev.${abbrevKey}`)}/${year}`;
};

/** Primeiro dia do mês (N−1) atrás → último dia do mês corrente (UTC). */
export const lastNMonthsChartRange = (
  months: InspectionChartPeriodMonths,
  reference = new Date(),
): { dateFrom: string; dateTo: string } => {
  const year = reference.getUTCFullYear();
  const month = reference.getUTCMonth() + 1;
  const startTotalMonths = year * 12 + (month - 1) - (months - 1);
  const startYear = Math.floor(startTotalMonths / 12);
  const startMonth = (startTotalMonths % 12) + 1;

  return {
    dateFrom: `${startYear}-${pad(startMonth)}-01`,
    dateTo: `${year}-${pad(month)}-${pad(lastDayOfMonthUtc(year, month))}`,
  };
};
